<template>
    <el-popover v-if="mode=='PTE'" popper-class="core-dialog" placement="bottom"  width="400" trigger="hover">

        <div slot="reference" class="tag active pointer" @click="dialogVisible = true" style="font-size: 16px;">{{
            pteMode == "ptea" ? 'PTE A / UKVI' : 'PTE Core' }}</div>

        <div class="padding-s">
            <div class="bold mt center">{{$t('请选择你的考试类型')}}</div>
            <div class="bold margin-t">PTE Academic / UKVI:</div>
            <div class="margin-ts st">{{$t('用于全球大学申请，澳大利亚、新西兰的移民或工作等各类签证申请，英国工作或学生签证申请')}}</div>

            <div class="bold margin-t">PTE Core:</div>
            <div class="margin-ts st">{{$t('用于加拿大移民或工作签证申请')}}</div>

            <div class="flex flex-h-center flex-v-center margin-t" style="gap: 20px;">
                <el-button type="primary" :plain="pteMode != 'ptea'" @click="setMode('ptea')">PTE A / UKVI</el-button>
                <el-button type="primary" :plain="pteMode != 'ptec'" @click="setMode('ptec')">PTE Core</el-button>
            </div>
        </div>
    </el-popover>

</template>

<script>
export default {
    name: "coreDialog",
    
    data() {
        return {
            dialogVisible: false
        };
    },


    computed: {
        pteMode: function () {
            return this.$store.state.pteMode
        },

        mode: function () {
            return this.$store.state.mode
        },
    },
    methods: {
        setMode(val) {
            this.$store.commit('set_pte_mode', val)
        }
    },
};
</script>
<style>
.core-dialog {
    border-radius: 10px;
    top: 10px;
}
</style>
<style scoped>
.tag {
    color: #999;
    text-align: center;
    line-height: 20px;
    padding: 5px 15px;
    display: inline-block;
    border-radius: 15px;
    border: 1px solid #999;
}

.tag.item {
    width: 50px;
}

.tag.active {
    color: #f66;
    border: 1px solid #f66;
}

.tag.hover:hover {
    border: 1px solid #f66;
    background-color: #f66;
    color: #fff;
}
</style>